export const INIT = 'SETUP::INIT'

export function init(config) {
  return {
    type: INIT,
    payload: config,
  }
}
